import { Link } from 'react-router-dom';
import Logo from './Logo';

const quickLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
  { to: '/countries', label: 'Countries We Assist' },
  { to: '/visa-services', label: 'Visa Services' },
  { to: '/apply-now', label: 'Apply Now' },
  { to: '/apply-from-home', label: 'Apply From Home' },
  { to: '/track-application', label: 'Track Application' },
  { to: '/document-collection', label: 'Document Collection' },
  { to: '/faqs', label: 'FAQs' },
  { to: '/contact-us', label: 'Contact Us' },
];

const services = [
  'Visa Application Assistance',
  'Appointment Booking',
  'Document Review & Verification',
  'Apply From Home Service',
  'Application Tracking',
  'Corporate & Group Visa Support',
];

export default function Footer() {
  return (
    <footer>
      <div className="bg-primary-900 text-background-50">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 lg:px-12 py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <Logo variant="light" className="w-[180px] md:w-[210px]" />
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed mb-4">
                Professional visa support and processing assistance from Zambia. Helping individuals, families, and organisations with visa applications worldwide.
              </p>
              <div className="flex gap-3">
                <a href="https://www.facebook.com" target="_blank" rel="nofollow" className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 hover:bg-accent-500 transition-colors duration-200 cursor-pointer">
                  <i className="ri-facebook-fill text-sm"></i>
                </a>
                <a href="https://www.twitter.com" target="_blank" rel="nofollow" className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 hover:bg-accent-500 transition-colors duration-200 cursor-pointer">
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
                <a href="https://www.linkedin.com" target="_blank" rel="nofollow" className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 hover:bg-accent-500 transition-colors duration-200 cursor-pointer">
                  <i className="ri-linkedin-fill text-sm"></i>
                </a>
                <a href="https://www.instagram.com" target="_blank" rel="nofollow" className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 hover:bg-accent-500 transition-colors duration-200 cursor-pointer">
                  <i className="ri-instagram-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-base mb-4">Quick Links</h4>
              <ul className="space-y-2.5">
                {quickLinks.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-base mb-4">Our Services</h4>
              <ul className="space-y-2.5">
                {services.map((service) => (
                  <li key={service}>
                    <Link to="/visa-services" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                      {service}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-base mb-4">Contact Info</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-map-pin-line text-accent-400 text-sm"></i>
                  </div>
                  <span className="text-sm text-foreground-300 leading-relaxed">
                    Plot No. 1194, Corner of Lunzua Road / Addis Ababa Road, Lusaka, Zambia
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-accent-400 text-sm"></i>
                  </div>
                  <a href="tel:+260961311111" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                    +260 961 311 111
                  </a>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-accent-400 text-sm"></i>
                  </div>
                  <a href="mailto:info@pvs-zm.com" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                    info@pvs-zm.com
                  </a>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-global-line text-accent-400 text-sm"></i>
                  </div>
                  <a href="https://www.pvs-zm.com" target="_blank" rel="nofollow" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                    www.pvs-zm.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-accent-500">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 lg:px-12 py-5">
          <p className="text-xs md:text-sm text-background-50 leading-relaxed">
            <strong className="font-semibold">Disclaimer:</strong> Premium Visa Solutions is an independent visa support and application assistance company based in Zambia. We are not an embassy, consulate, immigration authority, or government office. Final visa decisions are made only by the relevant embassy, consulate, immigration department, or official visa authority.
          </p>
        </div>
      </div>

      <div className="bg-primary-950">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 lg:px-12 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Premium Visa Solutions. All rights reserved.
          </p>
          <p className="text-xs text-foreground-400">
            Built with trust. Powered by BRAND BOSS ZAMBIA.
          </p>
        </div>
      </div>
    </footer>
  );
}